import axios, { AxiosResponse } from 'axios';
import { FetchCatLoungesTypeWdw } from '../redux/lounges/slice';
import { Lounge } from '../redux/lounges/types';
import { GET_BASE_URL } from '../constants/apiEndpoints';
import { normalizeApiPage } from './pagination';
import { LOUNGE_GET_TIMEOUT_MS } from '../utils/loungeRequest';
export const getCatLoungesWdwApi = async ({
  landid,
  landname,
  sortType,
  LoungeId,
  currentPage,
  searchValue,
  shortByTime,
}: FetchCatLoungesTypeWdw) => {
  const responseBody = (response: AxiosResponse) => response.data;
  const token = localStorage.getItem('token');
  let sorvalue = null;
  const page = normalizeApiPage(currentPage);
  let sortByTime =
    shortByTime == 'true'
      ? `?page=${page}&sortordefault=ww`
      : `?page=${page}`;

  let pagename = landname
    .replace(/([/~!@#$%^&*()_+=`{}\[\]\|\\:;'<>,.\?\- ])+/g, ' ');

  if(landid == '5') localStorage.setItem('pagename', 'Wdw LoungeLand');
  else localStorage.setItem('pagename', landname);

  const apiEndpoint =
    GET_BASE_URL + `/api/v1/disneyworldHome/` + landid;

  if (searchValue != null) {
    const { data } = await axios
      .get<Lounge[]>(`${apiEndpoint}/search/post/${searchValue}${sortByTime}`, {
        headers: {
          Authorization: `bearer ${token}`,
        },
        timeout: LOUNGE_GET_TIMEOUT_MS,
      })
      .then(responseBody);
    return data.data;
  } else {
    const { data } = await axios
      .get<Lounge[]>(`${apiEndpoint}${sortByTime}`, {
        timeout: LOUNGE_GET_TIMEOUT_MS,
      })
      .then(responseBody);
    return data.data;
  }
};
